import {
  MQ_SMALL_ONLY,
  MQ_MEDIUM_DOWN,
  MQ_MEDIUM,
  MQ_MEDIUM_ONLY,
  MQ_LARGE,
  MQ_LARGE_ONLY,
  MQ_MIDLARGE,
  MQ_MIDLARGE_ONLY,
  MQ_MIDLARGE_DOWN,
  MQ_XLARGE
} from 'constants/mq';

// CLEANUP: Fix these units when post breakpoints are fixed
const cover = [
  {
    media: MQ_MIDLARGE_DOWN,
    isResponsive: true
  },
  {
    media: MQ_XLARGE,
    isResponsive: false,
    maxWidth: 1318
  }
];

const faqItem = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MEDIUM_ONLY,
    isResponsive: false,
    maxWidth: 684
  },
  {
    media: MQ_LARGE,
    isResponsive: false,
    maxWidth: 686
  }
];

const faqPage = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MEDIUM,
    isResponsive: true,
    maxWidth: 800
  }
];

const featuredEmailList = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: false,
    maxWidth: 160
  },
  {
    media: MQ_MEDIUM,
    isResponsive: false,
    maxWidth: 240
  }
];

// CLEANUP: This information is super similar to Gallery/variants.js
// I would love to figure out a way to centralize this for
// all Images and ImagePlaceholders
const sliderGallery = [
  {
    media: MQ_MEDIUM_DOWN,
    isResponsive: true
  },
  {
    media: MQ_LARGE_ONLY,
    isResponsive: false,
    maxWidth: 610,
    maxHeight: 610 / 1.5
  },
  {
    media: MQ_MIDLARGE_ONLY,
    isResponsive: false,
    maxWidth: 730,
    maxHeight: 730 / 1.5
  },
  {
    media: MQ_XLARGE,
    isResponsive: false,
    maxWidth: 816,
    maxHeight: 816 / 1.5
  }
];

const inPost = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MEDIUM_ONLY,
    isResponsive: false,
    maxWidth: 696,
    maxHeight: 696 * 1.25
  },
  {
    media: MQ_LARGE_ONLY,
    isResponsive: false,
    maxWidth: 610,
    maxHeight: 610 * 1.25
  },
  {
    media: MQ_MIDLARGE,
    isResponsive: false,
    maxWidth: 730,
    maxHeight: 730 * 1.25
  }
];

const interrupter = [
  {
    media: MQ_MEDIUM_DOWN,
    isResponsive: true
  },
  {
    media: MQ_LARGE_ONLY,
    isResponsive: false,
    maxWidth: 976
  },
  {
    media: MQ_MIDLARGE,
    isResponsive: false,
    maxWidth: 1148
  }
];

const prism = [
  {
    media: '(min-width: 0px)',
    isResponsive: true
  }
];

const product = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MEDIUM_ONLY,
    isResponsive: false,
    maxWidth: 348
  },
  {
    media: MQ_LARGE_ONLY,
    isResponsive: false,
    maxWidth: 305
  },
  {
    media: MQ_MIDLARGE,
    isResponsive: false,
    maxWidth: 365
  }
];

const wishListGrid = [
  {
    media: MQ_SMALL_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MEDIUM_ONLY,
    isResponsive: true
  },
  {
    media: MQ_LARGE_ONLY,
    isResponsive: true
  },
  {
    media: MQ_MIDLARGE,
    isResponsive: true
  }
];

// TODO this is the same as the more generic `responsive`
// below. Eventually we want to just use the generic version
// whenever we need a purely responsive placeholder.
const sideBySide = [
  {
    media: '(min-width: 0px)',
    isResponsive: true
  }
];

const responsive = [
  {
    media: '(min-width: 0px)',
    isResponsive: true
  }
];

export default {
  cover,
  faqItem,
  faqPage,
  featuredEmailList,
  inPost,
  interrupter,
  sliderGallery,
  prism,
  product,
  responsive,
  sideBySide,
  wishListGrid
};
